/* eslint-disable camelcase */
import React, { useEffect, useRef } from 'react';

import { Menu, MenuItem, MenuButton, FocusableItem } from '@szhsin/react-menu';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { WalletDetails } from 'components/WalletDetails';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import useLockedBody from 'hooks/useLockedBody';
import { WalletIcon } from 'styles/assets/icons';
import Box from 'UIKit/Box';

import PnlAnalyticsButton from '../../PnlAnalyticsButton/PnlAnalyticsButton';
import { TotalEquity } from './computeTotalBalance';
import styles from './index.module.scss';

// const menuClassName = ({ state }) => styles['wallet-menu-container'];

/* eslint-disable no-nested-ternary */

const CustomMenuButton = React.forwardRef(({ open, onClick }, ref) => {
  const buttonRef = useRef(null);

  useEffect(() => {
    if (ref) {
      // eslint-disable-next-line no-param-reassign
      ref.current = buttonRef.current;
    }
  }, [ref]);

  useLockedBody(open);

  return (
    <MenuButton
      ref={buttonRef}
      data-testid="switchUserMenuButton"
      className={`${open ? styles.active : ''} ${styles.button}`}
      id="wallet-button"
      onClick={onClick}
    >
      <WalletIcon width="18" height="18" />
    </MenuButton>
  );
});

CustomMenuButton.propTypes = {
  open: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const menuClassName = ({ state }) =>
  state === 'open'
    ? styles['wallet-menu-container-open']
    : state === 'close'
    ? styles['wallet-menu-container-close']
    : styles['wallet-menu-container'];

const WalletMenu = () => {
  const { t } = useTranslation(['headerFooter']);

  return (
    <Menu
      menuButton={({ open }) => (
        <CustomMenuButton
          data-testid="customSwitchUserMenuButton"
          open={open}
          onClick={() => {
            trackMixpanelEvent('Account icon clicked - All Pages - Header');
          }}
        />
      )}
      menuClassName={menuClassName}
    >
      <MenuItem className={styles['total-balance-details']}>
        <Box
          className={styles.headingContainer}
          data-testid="wallet-menu-account-container"
        >
          <div className={styles.heading}>
            <span className={styles.headingText}>
              {t('headerFooter:header.wallet.accountValue')}
            </span>
          </div>
          <PnlAnalyticsButton
            className={styles.analyticsRedirect}
            pageName="Wallet Drawer"
            showAsLink
            showLabel
            highlightLink
          />
        </Box>
        <TotalEquity
          // balancesArray={balanceArray}
          className={styles['total-balance']}
          usdClassName={styles['usd-value']}
          btcClassName={styles['btc-value']}
          hideBTC
        />
      </MenuItem>
      <FocusableItem className={styles.detailsContainer}>
        <WalletDetails />
      </FocusableItem>
    </Menu>
  );
};

export default WalletMenu;
